import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ApiCompanyInfo } from "../../types/company";
import { RootState } from "../store";


interface IStateProps {
  data: ApiCompanyInfo;
}

const initialState: IStateProps = {
  data: {
    Id: 0,
    NameEnglish: "",
    NameNepali: "",
    Pan_Vat: "",
    Address: "",
    Street: "",
    City: "",
    District: "",
    Phone: "",
    Email: "",
    BranchCode: "",
    IRD_UserName: "",
    IRD_Password: "",
    PhotoIdentity: "",
    IdentityFileType: "",
    IdentityFileName: "",
    ServiceCharge: 0,
    Description: "",
    VATRate: 0,
    ExciseDuty: 0,
    IRD_SYS: "",
    BillHeaderFront:"",
    FirstPageRow:0,
  },
};

export const companySlice = createSlice({
  name: "company",
  initialState,
  reducers: {
    setCompanyAction: (state, action: PayloadAction<ApiCompanyInfo>) => {
      state.data = action.payload;
    },
  },
});

export const { setCompanyAction } = companySlice.actions;

export const selectCompany = (state: RootState) => state.company.data;

export default companySlice.reducer;
